import * as React from 'react';
import Box from '@mui/material/Box';
import HomeTop from "../components/HomeTop";
import Bottom from "./Bottom";
import HistoryHome from './History/HistoryHome';
import Container from '@mui/material/Container';
import HistoryBurnKcal from './History/HistoryBurnKcal';
import HistoryDrinkWater from './History/HistoryDrinkWater';
import HistoryEatFood from './History/HistoryEatFood';
import HistoryWalking from './History/HistoryWalking';
import { BrowserRouter as Router, Routes,Route, Link } from 'react-router-dom';
import careStore from "../store/careStore";
import {useEffect} from "react";

const History = () => {
  const storeData1: any = careStore();
  
  useEffect(() => {
    
    return () => {
      storeData1.setCareInfo('height', 0);
      storeData1.setCareInfo('weight', 0);
      storeData1.setCareInfo('reset', '');
    }
  }, []);
    
  return (
    <Container sx={{p: '0 !important', bgcolor: '#F6F6F6', minWidth: 320,minHeight: '100vh'  }}>
      {/* <HomeTop/> */}
      
      <HistoryHome/>
      <Bottom/>
    </Container>
  );
}
export default History;